import { NextUpDesktopOnly } from 'NextUp';
import { WelcomeMessage } from 'WelcomeMessage';
import { StudyBox } from '../StudyBox';

export function MobileCourseware() {
    return (
        <div className="block sm:hidden">
            <div className="bg-white p-3">
                <WelcomeMessage />
            </div>
            <div className="mb-3.5">
                <StudyBox
                    card={false}
                    segmentedControlClassNames={{ base: 'mt-0 pt-5 bg-white', tabList: 'bg-white' }}
                />
            </div>
        </div>
    );
}

export function DesktopCourseware() {
    return (
        <div className="hidden flex-col gap-3.5 sm:flex md:gap-7.5">
            <WelcomeMessage />
            <NextUpDesktopOnly />
            <StudyBox />
        </div>
    );
}
